import React from 'react';

const steps = [
  {
    num: '01',
    title: 'Discover',
    desc: 'Deep-dive into business goals, user research, and competitive landscape. We define scope, strategy, and success metrics before writing a single line.',
    delay: 'rv-d1',
  },
  {
    num: '02',
    title: 'Design',
    desc: 'Wireframes, interactive prototypes, and high-fidelity UI. Every screen is designed for clarity, delight, and conversion before development begins.',
    delay: 'rv-d2',
  },
  {
    num: '03',
    title: 'Develop',
    desc: 'Agile sprints with continuous integration and delivery. Modern tech stacks, rigorous code reviews, automated testing, and weekly demos.',
    delay: 'rv-d3',
  },
  {
    num: '04',
    title: 'Deploy & Scale',
    desc: 'Production launch with monitoring, analytics, and performance optimization. Ongoing support and iteration to ensure long-term growth.',
    delay: 'rv-d4',
  },
];

function Process() {
  return (
    <section id="process" className="section">
      <div className="accent-orb" style={{ width: 350, height: 350, top: '20%', right: -150, animationDelay: '3s' }}></div>

      <div className="section-inner">
        <div className="section-header-center rv">
          <span className="label-tag" style={{ marginBottom: '1.5rem', display: 'inline-block' }}>How We Work</span>
          <h2 className="section-title" style={{ marginBottom: '1.25rem' }}>
            From concept to<br />production in four steps
          </h2>
          <p className="section-desc">
            A battle-tested process refined over six years and 150+ projects. Transparent, collaborative, and built for results.
          </p>
        </div>

        <div className="process-grid">
          {steps.map((step, i) => (
            <div key={i} className={`process-block rv ${step.delay}`}>
              <p className="process-num">{step.num}</p>
              <h3>{step.title}</h3>
              <p>{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Process;
